const readRootCssVar = (name: string, fallback: string): string => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return fallback;
  }

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return value || fallback;
};

const readRootCssPx = (name: string, fallback: number): number => {
  const value = readRootCssVar(name, `${fallback}px`);
  const parsed = Number.parseInt(value, 10);

  return Number.isNaN(parsed) ? fallback : parsed;
};

const themeColorFallbacks = {
  "danger-600": "#dc2626",
  "gray-300": "#ededef",
  "gray-500": "#d3d2d8",
  "gray-600": "#868393",
  "gray-700": "#656175",
  "gray-800": "#201c3c",
  "primary-400": "#818cf8",
  "primary-500": "#5448ee",
  "secondary-500": "#ff4775",
} as const;

const themeTextFallbacks = {
  xs: "0.75rem",
  sm: "0.875rem",
} as const;

const breakpointFallbacks = {
  sm: 581,
  md: 768,
  lg: 976,
  xl: 1280,
  "2xl": 1536,
} as const;

const fontSansFallback =
  "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif";

export const getThemeColor = (
  token: keyof typeof themeColorFallbacks,
): string => {
  return readRootCssVar(`--color-${token}`, themeColorFallbacks[token]);
};

export const getThemeTextSize = (
  token: keyof typeof themeTextFallbacks,
): string => {
  return readRootCssVar(`--text-${token}`, themeTextFallbacks[token]);
};

export const getThemeFontSans = (): string => {
  return readRootCssVar("--font-sans", fontSansFallback);
};

export const getThemeBreakpoint = (
  token: keyof typeof breakpointFallbacks,
): number => {
  return readRootCssPx(`--breakpoint-${token}`, breakpointFallbacks[token]);
};
